import { render, staticRenderFns } from "./StackDatasets.vue?vue&type=template&id=5fd0a0cd&scoped=true&"
import script from "./StackDatasets.vue?vue&type=script&lang=js&"
export * from "./StackDatasets.vue?vue&type=script&lang=js&"
import style0 from "./StackDatasets.vue?vue&type=style&index=0&id=5fd0a0cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd0a0cd",
  null
  
)

export default component.exports